module.exports = __webpack_public_path__ + "assets/8495288e35ad2be56882f50ebcd64757.svg";